import { Waypoint } from "../../generated/gpb/api/route";
import { Feature, GeoJsonProperties, Geometry } from "geojson";
import { WaypointExpanded } from "../../features/riskViewer/riskViewerSlice";

// Define default bounds for the continental US
const defaultBounds: Array<Array<number>> = [ [ -125.0, 24.396308 ], [ -66.93457, 49.384358 ] ];

// Function to calculate the southwestern and northeastern corners for the route
export function getRouteBoundingBox( waypoints: Array<Waypoint> | Array<WaypointExpanded> | undefined ): Array<Array<number>>
{
    if ( !waypoints || waypoints.length === 0 ) return defaultBounds;

    let latMin = Number.POSITIVE_INFINITY;
    let latMax = Number.NEGATIVE_INFINITY;
    let lngMin = Number.POSITIVE_INFINITY;
    let lngMax = Number.NEGATIVE_INFINITY;

    waypoints.forEach( waypoint =>
    {
        const lat = waypoint.location?.location?.latitude;
        const lon = waypoint.location?.location?.longitude;

        if ( lat !== undefined && lat < latMin ) latMin = lat;
        if ( lat !== undefined && lat > latMax ) latMax = lat;
        if ( lon !== undefined && lon < lngMin ) lngMin = lon;
        if ( lon !== undefined && lon > lngMax ) lngMax = lon;
    } );

    // Add padding around the bounds
    const padding = 0.15;
    const latPadding = ( latMax - latMin ) * padding;
    const lngPadding = ( lngMax - lngMin ) * padding;

    const southwest: Array<number> = [ lngMin - lngPadding, latMin - latPadding ];
    const northeast: Array<number> = [ lngMax + lngPadding, latMax + latPadding ];

    return [ southwest, northeast ];
}

export const getLineString = ( waypoints: Array<WaypointExpanded> ) =>
{
    return {
        type: "Feature" as const,
        geometry: {
            type: "LineString",
            coordinates: waypoints.map(
                ( waypoint ) => [ waypoint.location?.location?.longitude, waypoint.location?.location?.latitude ]
            ).filter( coord => coord[0] !== undefined && coord[1] !== undefined )
        },
        properties: {}
    } as Feature<Geometry, GeoJsonProperties>;
};
